import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription, forkJoin, of } from 'rxjs';
import { InvoiceService } from '../../services/invoice.service';
import { environment } from 'src/environments/environment';

export interface InvoiceError {
  statusCode: number;
  reason: string;
  createdAt: string;
}

export interface InvoiceListItem {
  id: number;
  indicationId: number;
  nfeId: string | null;
  statusNf: string | null;
  pdfUrl: string | null;
  xmlUrl: string | null;
  createdAt: string;
  updatedAt: string;
  countLogs: number;
  errors?: InvoiceError[];
}

@Component({
  selector: 'app-invoice-list',
  templateUrl: './invoice-list.component.html',
  styleUrls: ['./invoice-list.component.scss'],
})
export class InvoiceListComponent implements OnInit, OnDestroy {
  loading = false;
  dataSource = new MatTableDataSource<InvoiceListItem>([]);
  displayedColumns = [
    'indicationId',
    'nfeId',
    'statusNf',
    'createdAt',
    'updatedAt',
    'actions',
    'errors',
  ];
  showErrorModal = false;
  modalErrors: InvoiceError[] = [];
  private subs = new Subscription();

  constructor(private invoiceService: InvoiceService) {}

  ngOnInit(): void {
    this.loadInvoices();
  }

  loadInvoices(): void {
    this.loading = true;
    this.subs.add(
      this.invoiceService.getAll().subscribe(
        (res) => {
          this.dataSource.data = res;
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      )
    );
  }

  openErrorModal(item: InvoiceListItem): void {
    if (!item.countLogs) {
      return;
    }
    this.invoiceService.getErrors(item.id).subscribe((errs) => {
      this.modalErrors = errs.map((r) => ({
        statusCode: r.statusCode,
        reason: r.reason,
        createdAt: this.formatDate(r.createdAt),
      }));
      this.showErrorModal = true;
    });
  }

  closeModal(): void {
    this.showErrorModal = false;
    this.modalErrors = [];
  }

  download(url: string | null): void {
    if (url) {
      window.open(url, '_blank');
    }
  }

  formatDate(dateStr: string): string {
    const d = new Date(dateStr);
    return d.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }

  generateInvoiceLink(nfeId: string): string {
    const raw = nfeId.replace(/^inv_0*/, '');
    return `${environment.asaasInvoiceLink}${raw}`;
  }

  getErrorIcon(count: number): string {
    const icons: Record<number, string> = {
      1: 'looks_one',
      2: 'looks_two',
      3: 'looks_3',
    };
    return icons[count] || '';
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
